module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-btn', {
    attrs: {
      "primary": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.actualizarcliente()
      }
    }
  }, [_vm._v("Actualizar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "accent": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.regresar()
      }
    }
  }, [_vm._v("Regresar")])], 1), _vm._v(" "), _c('GmapMap', {
    staticStyle: {
      "width": "100%",
      "height": "80vh"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 18,
      "map-type-id": "hybrid"
    },
    on: {
      "click": function($event) {
        return _vm.marcar($event)
      }
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('GmapMarker', {
      key: index,
      attrs: {
        "position": m.position,
        "clickable": true,
        "draggable": true,
        "label": _vm.cliente.nombre
      },
      on: {
        "click": function($event) {
          _vm.center = m.position
        }
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b73ee58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ActualizaUbicacionCliente.vue
// module id = 429
// module chunks = 1